
import React from 'react'
import NavLink from './NavLink'

import NavBar from '../../components/NavBar/NavBar.jsx'
import MultiTaskManager from '../../components/MultiTaskManager'

import { user } from '../../core/controllers/user';
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager';
import { modal } from '../../core/utilities/modal';
import { billing } from '../../core/controllers/Billing'
import UpcomingTasks from "../UpcomingTasks/UpcomingTasks.jsx";
import Logo from '../Logo/Logo';
import LogoIcon from '../Logo/LogoIcon';

// To avoid lengthy ||s
const isAny = (value, ...anyis) => {
    let found = false;
    for (let check of anyis) {
        if (value == check){
            found = true;
            break;
        }
    }
    return found;
}

function SideBarLogo(props) {
    return (
        <div class="logo" style={props.small ? {marginInline: "15px"} : {}}>
            {props.small ? (
                <div style={{width: "35px", objectFit: "cover", overflow: "hidden"}}>
                    <LogoIcon width={35} square />
                </div>
            ) : (
                <Logo height={43.5} />
            )}
        </div>
    );
}

function SideBarLogOut(props) {
    return (
        <li class="log-out-mobile">
            <a>
                <div style={{display:"flex"}}>
                    <i onClick={props.logOff} class="fa fa-sign-out" />
                    {!props.showSmall && (<p onClick={props.logOff}>Log Out</p>)}
                </div>
            </a>
        </li>
    );
}

function SideBarBankVerify() {
    return (<div class="activation">
        <p class="text-activation">You have not verified one or more bank accounts. Navigate to the "Payments" tab to verify!</p>
        <NavLink to="/account/billing">
            <button type="button" class="btn btn-info btn-primary btn-fill" autoComplete="off">
                Go to Payments
            </button>
        </NavLink>
    </div>);
}

function SideBarEmailVerify(props) {
    return (<div class="activation">
        <p class="text-activation">You have not confirmed your account! Please check the email for the activation link to confirm your account, or click the button below to resend the email!</p>
        <button type="button" class="btn btn-info btn-primary btn-fill" autoComplete="off" onClick={props.handleSendActivationEmail}>
            Resend Activation Email
        </button>
    </div>);
}

function SideBarAdminBilling(props) {
    return (<li>
        <NavLink to="/account/billing">
            <div style={props.showSmall ? {display: "flex"} : {}}>
                <i class="icon-credit-card-outline" style={props.showSmall ? {color: props.styles.color} : {}}/>
            </div>
            <p style={props.showSmall ? {display: "none"} : {}}>
                Payments
                <i class="pe-7s-check" style={props.styles}/>
            </p>
        </NavLink>
    </li>);
}

const types = React.PropTypes
const propPermissionValidator = props => {props.children}
propPermissionValidator.propTypes = {
    permission: types.arrayOf(types.string).isRequired,
   iconStyle: types.object.isRequired,
    permiss: types.string.isRequired
}

import ReactWithAddons from 'react/dist/react-with-addons'

function SidebarItem(props) {
    if (props.requiresPermission){
        var hasPermission = props.permission.includes(props.permis)
    }
    const notSatisfyPermission = (props.requiresPermission === true) && !hasPermission
    const content = ReactWithAddons.addons.createFragment({
        "title": props.title,
        "permission": notSatisfyPermission && (
            <propPermissionValidator {...props}>
                <i class="icon-lock-locked" style={props.iconStyle}/>
            </propPermissionValidator>
        )
    })
    return(
        <li>
            <NavLink 
                to={props.url} 
                onlyActiveOnIndex={props.index || props.showSmall}
            >
                <div style={{display: "flex"}}>
                    <i class={props.icon}></i>
                    {props.showSmall ? (
                        <p>{content.permission}</p>
                    ) : (
                        <p>{content}</p>
                    )}
                </div>
            </NavLink>
        </li>
    )
}

SidebarItem.propTypes = {
    index: types.bool,
    requiresPermission: types.bool,
    url: types.string.isRequired,
    icon: types.string.isRequired,
    title: types.string.isRequired,
}

function MainPanel(props) {
    const styleShowUpcoming = <style>{`
        .main-panel-tasks { 
            /*width: calc(83.33333332% - 260px) !important;
            float: unset !important;*/
        }
        @media (max-width: 992px) {
            .main-panel-tasks {
                display: none !important;
            }
        }
    `}</style>
    const doNothing = () => {}
    return (
        <div 
            class={props.showUpcoming ? "main-panel-tasks main-panel" : "main-panel"} 
            id="main" 
            style={{width: "100%", left:"unset"}}
        >
            {props.userHasPendingBankAccounts == true && (
                <SideBarBankVerify/>
            )}
            {props.renderEmailVerify && (
                <SideBarEmailVerify handleSendActivationEmail={props.handleSendActivationEmail}/>
            )}
            {styleShowUpcoming}
            <div class="blue-top"></div>
            <NavBar
                toggleUpcoming={(user.userInfo.view == '0' || user.userInfo.view == '1') ? (
                        props.updateShowUpcoming
                    ) : (
                        doNothing
                    )}
                upcomingActive={props.showUpcoming}
                toggleSidebar={props.toggleSidebar}
                showUpcomingToggle={props.showUpcomingToggle}
                unloadUser={props.unloadUser}
            />
            <div class="content">
                <div class="container-fluid">
                    {props.children}
                </div>
            </div>
        </div>
    );
}

function SideBar(props) {
    const wrapProps = {}
    if (props.permission){ wrapProps.permission = props.permission }
    if (props.iconStyle){ wrapProps.IconStyle = props.permission }
    if (props.wrapPermission){ wrapProps.requiresPermission = props.requiresPermission }

    return(
        <div class="sidebar" style={props.showSmall ? {overflowX: "hidden", width:"100px", display: "unset"} : {display: "unset"}}>
            <div class="sidebar-wrapper" style={{ width: "unset" }}>
                <SideBarLogo logoUrl={props.logoUrl} small={props.showSmall}></SideBarLogo>
                <ul class="nav">
                    {
                        props.children.map((child, index) => {
                            return (
                                React.cloneElement(child, {
                                    ...wrapProps,
                                    ...child.props,
                                    showSmall: props.showSmall,
                                    key: `sidebar-item-${index}`
                                })
                            )
                        })
                    }
                    {window.innerWidth < 992 && (
                        <SideBarLogOut
                            showSmall={props.showSmall}
                            logOff={props.logOff}
                        />
                    )}
                </ul>
            </div>
        </div>
    )
}

export default class Routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userLoaded: false,
            userHasBankAccounts: false,
            userHasPendingBankAccounts: false,
            showUpcoming: false,
            mobileView: null,
            showSidebar: null
        }
    }

    componentDidMount() {
        var self = this;
        this.reload(true) // Reload and get pending bank accounts
        user.setReload(this.reload.bind(this));
        multiTaskerManager.setReload(this.reload.bind(this));

        this.updateShowUpcoming = () => {
            self.setState({
                showUpcoming: !self.state.showUpcoming
            })
        }

        this.updateShowSidebar = () => {
            self.setState({
                showSidebar: !self.state.showSidebar
            })
        }

        this.mobileTarget = window.matchMedia("(max-width: 992px)") // Retain the target so the event listener can be unmounted
        this.hideTasksListener = event => { // Define the event lister
            if (event.matches) { // Window has gone from desktop to mobile view
                this.setState({
                    showUpcoming: false,
                    mobileView: true,
                    showSidebar: false
                })
            }
            else { // mobile to desktop
                this.setState({
                    mobileView: false,
                    showSidebar: true
                })
            }
        }
        this.mobileTarget.addEventListener("change", this.hideTasksListener) // Add an event listener for showing the icons
        this.setState({
            mobileView: this.mobileTarget.matches,
            showSidebar: !this.mobileTarget.matches
        })
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener) // Remove the event listener
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.location.pathname == '/' && nextState.userLoaded === false) {
            this.reload()
        }
    }

    unloadUser = () => {
        this.setState({
            userLoaded: false,
            userHasBankAccounts: false,
            userHasPendingBankAccounts: false,
            showUpcoming: false,
            showSidebar: true
        })
    }

    reload(getHasPending=false) {
        var self = this;
        user.getUserDataWithCallback(function (response) {
            user.getPermissions(function (response) {
                billing.getProfile(function (billing) {
                    if (billing) {
                        if (billing.data.banks.length > 0) {
                            if (getHasPending) {
                                billing.data.banks.map(function (bank) {
                                    if (bank.status == "PENDING") {
                                        self.setState({
                                            userHasPendingBankAccounts: true
                                        })
                                    }
                                })

                            }
                            self.setState({
                                userHasBankAccounts: true,
                                userLoaded: true
                            })
                        } else {
                            self.setState({
                                userLoaded: true
                            });
                        }
                    } else {
                        self.setState({
                            userLoaded: true
                        });
                    }
                }, false);
            });
        });
    }

    handleSendActivationEmail() {
        user.resendEmailActivation(function (response) {
            modal.showInfo("An activation email has been sent again. Please click the link in the email to confirm your account!", "success", "top", "center");
        })
    }

    logOff(e) {
        user.logUserOff();
    }

    render() {
        var userType;
        const userLoaded = this.state.userLoaded;
        var logoUrl = '/assets/img/logo_no_tag.png';
        var iconStyle = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
        var permissions = Array();
        if (userLoaded) {
            if (user.userInfo.logo) {
                logoUrl = user.userInfo.logo.url;
            }
            userType = user.userInfo.user_type_alias;
            permissions = user.userPermissions;
        }
        if (isAny(this.props.location.pathname, "/login", "/signup", "/forgot", "/screen", "/getstarted", "/vendor/login") || this.state.userLoaded === false) {
            return (
                <div>
                    {this.props.children}
                </div>
            )
        } else if (userType == 'tenant') 
                return (
                    <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                        {this.state.showSidebar && (
                            <div className="sidebar-grid" style={this.state.showSidebar ? (
                                this.state.mobileView ? { width: "100px" } : { width: "260px" }
                            ) : (
                                { width: "0px" }
                            )}
                            >
                                <SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem url="/" index icon={"icon-bar-chart-outline"} title="Dashboard" />
                                    <SidebarItem url="/account/payonline" icon={"icon-credit-card-outline"} title="Payments" />
                                    <SidebarItem url="/account/billing" icon={"icon-bank"} title="Billing" />
                                    <SidebarItem url="/maintenance/order/new" icon={"icon-wrench-outline"} title="Maintenance" />
                                    <SidebarItem url="/lease" icon={"icon-paper-outline"} title="Lease" />
                                    <SidebarItem url="/request/renters" icon={"icon-price-tag-outline"} title="Renters Insurance" />
                                </SideBar>
                            </div>
                        )}
                        <div className="main-grid">
                            <MainPanel 
                                showUpcoming={false} 
                                updateShowUpcoming={this.updateShowUpcoming}
                                toggleSidebar={this.updateShowSidebar}
                                userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                unloadUser={this.unloadUser.bind(this)}
                            >
                                {this.props.children}
                            </MainPanel>
                        </div>
                    </div>
                )
             else if (userType == 'contractor') {
                return (
                    <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                        {this.state.showSidebar && (
                            <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    this.state.mobileView ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                <SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem url="/" index icon={"icon-bar-chart-outline"} title="Dashboard"/>
                                    <SidebarItem url="/maintenance" icon={"icon-wrench-outline"} title="Maintenance"/>
                                    {/*<SidebarItem url="/activity" icon={"pe-7s-box1"} title="Activity Log"/>*/}
                                </SideBar>
                            </div>
                        )}
                        <div className="main-grid">
                            <MainPanel 
                                showUpcoming={false} 
                                updateShowUpcoming={this.updateShowUpcoming}
                                toggleSidebar={this.updateShowSidebar}
                                userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                unloadUser={this.unloadUser.bind(this)}
                            >
                                {this.props.children}
                            </MainPanel>
                        </div>
                    </div>
                )
            } else if (userType == 'owner') {
                if (!user.userInfo.billing_setup) {
                    var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                } else {
                    if (this.state.userHasBankAccounts == true) {
                        var styles = { float: 'right', fontSize: '18px', color: '#34b417', fontWeight: '600' };
                    } else {
                        var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                    }
                }
                return (
                    
                    <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                        {this.state.showSidebar && (
                            <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    this.state.mobileView ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                <SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem url="/" index icon={"icon-bar-chart-outline"} title="Dashboard"/>
                                    <SidebarItem requiresPermission url="/properties" icon="icon-house-outline" title="Properties" permis='properties' style={iconStyle} permission={permissions}/>
                                    <li>
                                        <NavLink to="/account/billing">
                                            <i class="icon-credit-card-outline"></i>
                                            <p>Payments<i class="pe-7s-check" style={styles}></i></p>
                                        </NavLink>
                                    </li>
                                </SideBar>
                            </div>
                        )}
                        <div className="main-grid">
                            <MainPanel 
                                showUpcoming={false} 
                                updateShowUpcoming={this.updateShowUpcoming}
                                toggleSidebar={this.updateShowSidebar}
                                userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                unloadUser={this.unloadUser.bind(this)}
                            >
                                {this.props.children}
                            </MainPanel>
                        </div>
                    </div>
                )
            } else if (userType == 'vendor') {
                return (
                    <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                        {this.state.showSidebar && (
                            <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    this.state.mobileView ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                <SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem url="/" index icon={"icon-bar-chart-outline"} title="Dashboard"/>
                                    <SidebarItem url="/account/billing" icon={"icon-credit-card-outline"} title="Payments"/>
                                    <SidebarItem url="/bills" icon={"icon-bank"} title="Bills"/>
                                </SideBar>
                            </div>
                        )}
                        <div className="main-grid">
                            <MainPanel 
                                showUpcoming={false} 
                                updateShowUpcoming={this.updateShowUpcoming}
                                toggleSidebar={this.updateShowSidebar}
                                userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                unloadUser={this.unloadUser.bind(this)}
                            >
                                {this.props.children}
                            </MainPanel>
                        </div>
                    </div>
                )
            } else {
                var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                if ((user.userInfo.user_type_alias == 'admin' || user.userInfo.user_type_alias == 'property-manager') && (user.userInfo.billing_setup && this.state.userHasBankAccounts == true)) {
                    styles.color = '#34b417'
                    styles.fontWeight = '600'
                }
                if (user.userInfo.view == '0' || user.userInfo.view == '1') {
                    let children = [
                        <SidebarItem requiresPermission url="/" index icon="icon-bar-chart-outline" title="Dashboard" permis='dashboard' style={iconStyle} permission={permissions}/>
                    ]
                    user.userInfo.user_type_alias == 'admin' && (
                        children.push(
                            <SideBarAdminBilling styles={styles}></SideBarAdminBilling>
                        )
                    )
                    children.push(
                        <SidebarItem requiresPermission url="/properties" icon="icon-house-outline" title="Properties" permis='properties' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/leases" icon="icon-paper-outline" title="Leases" permis='leases' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/tenants" id="tenantsAssets" icon="icon-person-outline" title="Tenants" permis='tenants' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/owners" icon="icon-person-group" title="Owners" permis='owners' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/reports" icon="icon-menu-chart-outline" title="Reports" permis='reports' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/financial" icon="icon-graph-outline" title="Financials" permis='financials' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/payables" icon="icon-wallet" title="Payables" permis='payables' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/quickbooks" icon="icon-key-outline" title="QuickBooks" permis='quickbooks' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/leads" icon="icon-star-outline" title="Leads" permis='leads' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/maintenance" icon="icon-wrench-outline" title="Maintenance" permis='maintenance' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/listings" icon="icon-price-tag-outline" title="Listings" permis='listings' style={iconStyle} permission={permissions}/>,
                        <SidebarItem requiresPermission url="/collaborator" icon="icon-box-list-outline" title="Tasks" permis='collaborator' style={iconStyle} permission={permissions}/>
                    )
                    return (
                        <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                            <div className="sidebar-grid" style={this.state.showSidebar ? ((this.state.showUpcoming || this.state.mobileView) ? {width: "100px"} :{width: "260px"}) : {width: "0px"}}>
                                {!(this.state.mobileView && this.state.showUpcoming) && this.state.showSidebar && (
                                    <SideBar logoUrl={logoUrl}
                                        logOff={this.logOff}
                                        routesChildren={this.props.children}
                                        showUpcoming={this.state.showUpcoming}
                                        showSmall={this.state.showUpcoming || this.state.mobileView}
                                        updateShowUpcoming={this.updateShowUpcoming}
                                    >
                                        {children}
                                    </SideBar>
                                )}
                                
                            </div>
                            <div className="main-grid">
                                <MainPanel 
                                    showUpcoming={this.state.showUpcoming} 
                                    showUpcomingToggle
                                    updateShowUpcoming={this.updateShowUpcoming}
                                    toggleSidebar={this.updateShowSidebar}
                                    renderEmailVerify={user.userInfo.status == "3"}
                                    userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                    handleSendActivationEmail={this.handleSendActivationEmail.bind(this)}
                                    unloadUser={this.unloadUser.bind(this)}
                                >
                                    {this.props.children}
                                </MainPanel>
                            </div>
                            {this.state.showUpcoming && (
                                <div className="">
                                    <UpcomingTasks
                                        toggleVisible={this.updateShowUpcoming}
                                        permissions={user.userPermissions ? (
                                            user.userPermissions.includes("future-tasks")
                                        ) : (
                                            false
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                    )
                } else if (user.userInfo.view == '2') {
                    //if ((user.userInfo.user_type_alias == 'admin' || user.userInfo.user_type_alias == 'property-manager') && !user.userInfo.billing_setup) {
                    //    var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                    //}
                    //if ((user.userInfo.user_type_alias == 'admin' || user.userInfo.user_type_alias == 'property-manager') && user.userInfo.billing_setup) {
                    //    if (this.state.userHasBankAccounts == true) {
                    //        var styles = { float: 'right', fontSize: '18px', color: '#34b417', fontWeight: '600' };
                    //    } else {
                    //        var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                    //    }
                    //}
                    return (
                        <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                        <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    (this.state.showUpcoming || this.state.mobileView) ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                {this.state.showSidebar && (<SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem requiresPermission url="/" onlyActiveOnIndex icon="icon-bar-chart-outline" title="Dashboard" permis='dashboard' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/properties" icon="icon-house-outline" title="Properties" permis='properties' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/buildings" icon="icon-connected-outline" title="Connected" permis='connected' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/payables" icon="icon-wallet" title="Payables" permis='payables' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/maintenance" icon="icon-wrench-outline" title="Maintenance" permis='maintenance' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/collaborator" icon="icon-box-list-outline" title="Tasks" permis='collaborator' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/warranty" icon="icon-ribbon-outline" title="Warranties" permis='warranty' style={iconStyle} permission={permissions}/>
                                </SideBar>)}
                            </div>
                            <div className="main-grid">
                                <MainPanel 
                                    showUpcoming={false} 
                                    updateShowUpcoming={this.updateShowUpcoming}
                                    toggleSidebar={this.updateShowSidebar}
                                    renderEmailVerify={user.userInfo.status == "3"}
                                    userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                    handleSendActivationEmail={this.handleSendActivationEmail.bind(this)}
                                    unloadUser={this.unloadUser.bind(this)}
                                >
                                    {this.props.children}
                                </MainPanel>
                            </div>
                        </div>
                        
                    )
                } else if (user.userInfo.view == '3') {
                    //if ((user.userInfo.user_type_alias == 'admin' || user.userInfo.user_type_alias == 'property-manager') && !user.userInfo.billing_setup) {
                    //    var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                    //}
                    //if ((user.userInfo.user_type_alias == 'admin' || user.userInfo.user_type_alias == 'property-manager') && user.userInfo.billing_setup) {
                    //    if (this.state.userHasBankAccounts == true) {
                    //        var styles = { float: 'right', fontSize: '18px', color: '#34b417', fontWeight: '600' };
                    //    } else {
                    //        var styles = { float: 'right', fontSize: '18px', color: 'gray', fontWeight: '500' };
                    //    }
                    //}
                    return (
                        <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                            <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    (this.state.showUpcoming || this.state.mobileView) ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                {this.state.showSidebar && (<SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem requiresPermission url="/" onlyActiveOnIndex icon="icon-bar-chart-outline" title="Dashboard" permis='dashboard' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/properties" icon="icon-house-outline" title="Properties" permis='properties' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/buildings" icon="icon-connected-outline" title="Connected" permis='connected' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/maintenance" icon="icon-wrench-outline" title="Maintenance" permis='maintenance' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/leases" icon="icon-paper-outline" title="Leases" permis='leases' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/tenants" id="tenantsAssets" icon="icon-person-outline" title="Tenants" permis='tenants' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/owners" icon="icon-person-group" title="Owners" permis='owners' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/reports" icon="icon-menu-chart-outline" title="Reports" permis='reports' style={iconStyle} permission={permissions}/>
                                    {user.userInfo.user_type_alias == 'admin' && (
                                        <SideBarAdminBilling styles={styles}></SideBarAdminBilling>
                                    )}
                                    <SidebarItem requiresPermission url="/leads" icon="icon-star-outline" title="Leads" permis='leads' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/listings" icon="icon-price-tag-outline" title="Listings" permis='listings' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/financial" icon="icon-graph-outline" title="Financials" permis='financials' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/payables" icon="icon-wallet" title="Payables" permis='payables' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/collaborator" icon="icon-box-list-outline" title="Tasks" permis='collaborator' style={iconStyle} permission={permissions}/>
                                    <SidebarItem requiresPermission url="/warranty" icon="icon-ribbon-outline" title="Warranties" permis='warranty' style={iconStyle} permission={permissions}/>
                                </SideBar>)}
                            </div>
                            <div className="main-grid">
                                <MainPanel 
                                    showUpcoming={false} 
                                    updateShowUpcoming={this.updateShowUpcoming}
                                    toggleSidebar={this.updateShowSidebar}
                                    renderEmailVerify={user.userInfo.status == "3"}
                                    userHasPendingBankAccounts={this.state.userHasPendingBankAccounts}
                                    handleSendActivationEmail={this.handleSendActivationEmail.bind(this)}
                                    unloadUser={this.unloadUser.bind(this)}
                                >
                                    {this.props.children}
                                </MainPanel>
                            </div>
                        </div>
                    )
                } else if (user.userInfo.user_type_alias == 'super-admin') {
                    return (
                        <div className="app-grid" style={{gridTemplateAreas: "'sidebar main'"}}>
                            <div className="sidebar-grid" style={ this.state.showSidebar ? (
                                    (this.state.showUpcoming || this.state.mobileView) ? {width: "100px"} :{width: "260px"}
                                ) : (
                                    {width: "0px"}
                                )}
                            >
                                {this.state.showSidebar && (<SideBar logoUrl={logoUrl}
                                    logOff={this.logOff}
                                    routesChildren={this.props.children}
                                    showSmall={this.state.mobileView}
                                >
                                    <SidebarItem url="/" index icon={"icon-bar-chart-outline"} title="Dashboard"/>
                                    <SidebarItem url="/admin/users" icon={"icon-person-group"} title="Managers"/>
                                    <SidebarItem url="/admin/tenants" icon={"icon-person-key"} title="Tenants"/>
                                    <SidebarItem url="/admin/owners" icon={"icon-key-outline"} title="Owners"/>
                                    <SidebarItem url="/admin/contractors" icon={"icon-wrench-outline"} title="Contractors"/>
                                    <SidebarItem url="/admin/subscriptions" icon={"icon-piggy-bank"} title="Subscriptions"/>
                                    <SidebarItem url="/admin/transactions" icon={"icon-credit-card-outline"} title="Transactions"/>
                                    <SidebarItem url="/admin/sensors" icon={"icon-sensor"} title="Sensors"/>
                                    <SidebarItem url="/admin/integrations" icon={"icon-connected-outline"} title="Integrations"/>
                                    <SidebarItem url="/admin/admins" icon={"icon-star-outline"} title="Admins"/>
                                </SideBar>)}
                            </div>
                            <div className="main-grid">
                                <MainPanel 
                                    showUpcoming={false} 
                                    updateShowUpcoming={this.updateShowUpcoming}
                                    toggleSidebar={this.updateShowSidebar}
                                    unloadUser={this.unloadUser.bind(this)}
                                >
                                    {this.props.children}
                                </MainPanel>
                            </div>
                        </div>

                    )
                }
            }
        }
};



// WEBPACK FOOTER //
// app/components/Routes/Routes.jsx